import { combineReducers } from 'redux'
import meta from 'state/slices/app/meta'
import brokers from 'state/slices/app/brokers'
import priceHistories from 'state/slices/app/priceHistories'
import brokerHistories from 'state/slices/app/brokerHistories'

export const app = combineReducers({ meta, brokers, priceHistories, brokerHistories })
